import Link from 'next/link';
import React from 'react';
import { useCustomerly } from 'react-live-chat-customerly';
import { Button } from '@/components/ui/Button';
import Image from 'next/image';

const Footer = () => {
  // Static data to replace translations
  const footerStrings = {
    links: 'Link utili',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
    termsOfService: 'Termini di Servizio',
    contactUs: 'Contattaci',
    copyright: `© ${new Date().getFullYear()} Trovanorma by Endless Creativity S.r.l. Tutti i diritti riservati.`,
  };

  const { open } = useCustomerly();
  const handleContactUsClick = () => {
    open();
  };

  return (
    <footer className="bg-primary-700 text-neutral-400 pt-12 pb-8 px-4">
      <div className="container max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-8 text-sm">
        {/* Sezione Informazioni Aziendali */}
        <div className="flex flex-col items-start">
          <h3 className="font-bold text-lg mb-3 text-white font-funnel">
            <Image
              src="/images/logo-horizontal-white.svg"
              alt="Trovanorma"
              width={140}
              height={24}
              className="inline-block"
            />
          </h3>
          <p className="font-bold mb-1">Endless Creativity S.r.l.</p>
          <p className="mb-1">Via Alberico Albricci 8</p>
          <p className="mb-1">20122 Milano MI (Italia)</p>
          <p className="mb-1">P.IVA: IT14287600960</p>
        </div>

        {/* Sezione Link Utili */}
        <div className="flex flex-col items-start sm:items-end">
          <h3 className="font-bold text-lg mb-3 text-white font-funnel">{footerStrings.links}</h3>
          <ul className="space-y-1 text-left sm:text-right">
            <li>
              <Link
                href="/privacy/"
                target="_blank"
                className="hover:underline hover:text-blue-400 transition-colors duration-200"
              >
                {footerStrings.privacyPolicy}
              </Link>
            </li>
            <li>
              <Link
                href="/cookie/"
                target="_blank"
                className="hover:underline hover:text-blue-400 transition-colors duration-200"
              >
                {footerStrings.cookiePolicy}
              </Link>
            </li>
            <li>
              <Link
                href="/terms/"
                className="hover:underline hover:text-blue-400 transition-colors duration-200"
              >
                {footerStrings.termsOfService}
              </Link>
            </li>
            <li>
              <Button
                variant="link"
                size="sm"
                onClick={handleContactUsClick}
                className="hover:underline hover:text-blue-400 transition-colors duration-200 text-neutral-400 h-auto underline-offset-1 my-0 py-0 px-0 font-normal"
              >
                {footerStrings.contactUs}
              </Button>
            </li>
          </ul>
        </div>

        {/* Sezione Contatti/Social (per le icone usare Lucide che dovrebbe averle) */}
        {/*
                <div className="flex flex-col items-start">
                    <h3 className="font-bold text-lg mb-3 text-white">Seguici</h3>
                    <div className="flex space-x-4">
                        <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                           aria-label="Facebook">
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path fillRule="evenodd"
                                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33V22C17.343 21.128 22 16.991 22 12z"
                                      clipRule="evenodd"/>
                            </svg>
                        </a>
                        <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                           aria-label="LinkedIn">
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.062 2.062 2.062 0 012.063-2.062c1.136 0 2.064.926 2.064 2.062a2.062 2.062 0 01-2.064 2.062zm1.782 13.019H3.555V9h3.564v11.452zM22.227 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.456c.979 0 1.773-.773 1.773-1.729V1.729C24 .774 23.206 0 22.227 0z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            */}
      </div>
      <div className="text-center mt-8 text-xs text-gray-400 border-t border-gray-700 pt-4">
        {footerStrings.copyright}
      </div>
    </footer>
  );
};

export default Footer;
